import { useGoogleLogin } from "@react-oauth/google";
import { SocialButtonProps } from "../../type";
import { GoogleGSvg } from "../../icons";

export default function GoogleLoginButton({ onSuccess, onError }: SocialButtonProps) {
  const login = useGoogleLogin({
    flow: 'implicit',
    onSuccess: (v) => onSuccess(v, 'google'),
    onError: (e) => onError(e)
  });

  return (
    <button type="button" onClick={() => login()} className="google_btn">
      <GoogleGSvg />
      <span>Google</span>
    </button>
  );
}
